/**
 * This component requires jQuery and Slick to function.
 */
import 'slick-carousel';
$(function () {
  $('[data-component="p2-360thrive-listing"]').each(function () {
    let $holder = $(this);
    $holder.slick({
      rows: 0,
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="icon-p2-left"></i></button>',
      nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="icon-p2-right"></i></button>',
      slidesToShow: 3,
      slidesToScroll: 1,
      focusOnSelect: true,
      focusOnChange: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1 // variableWidth: true,
          //  margin:20,

        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1 //  variableWidth: true,

        }
      }]
    });
  });
});